import React from 'react'

const Footer = (props) => {
    
    const nome = 'Prowedding'
    const piva = '02987940737'

    return (
        <footer className="uk-section-secondary">
            <div className="uk-section uk-section-xsmall" style={{backgroundColor: 'rgba(0,0,0,0.15)'}}>
                <div className="uk-container">
                    <div className="uk-grid uk-child-width-1-2@s uk-text-center uk-text-left@s" data-uk-grid="">
                        <div className="uk-text-small uk-text-muted">
                        <span className="uk-text-uppercase">© {new Date().getFullYear()} {nome} - P.IVA {piva}</span>
							</div>
                        <div className="uk-text-small uk-text-muted uk-text-center uk-text-right@s">
                            <a href="https://www.webartsdesign.it">Crafted with <span data-uk-icon="heart" className="uk-text-danger"></span> by Webartsdesign</a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer


// WEBPACK FOOTER //
// ./src/components/footer/footer/index.js